import { Grid, Paper, withStyles } from '@material-ui/core';
import { FormApi } from 'final-form';
import React from 'react'; // eslint-disable-line
import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { Submit, submitAction } from '../actions/submit';
import { ForensicInput, getForensicInput } from '../reducer';
import { FormSpy } from 'react-final-form';
import {
    validations,
    GenericForm,
    FormErrors,
    FormHeading,
    FullWidthDatePicker,
    FullWidthTextField,
    FullWidthSelectField,
} from '../../../../../forms';
import { OnSubmitSuccessProps } from '../../../../../workflow-navigation';
import styles, { StyledComponent } from '../../../../../styles/styles';
import { State } from '../../../../../redux/root-reducer';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { requiredValidator } from '../../../../../forms/validations';

interface OwnProps {}

interface StateProps {
    forensicInput?: ForensicInput;
}

interface DispatchProps {
    submit: Submit;
}

type Props = DispatchProps & OwnProps & StateProps & OnSubmitSuccessProps & StyledComponent;

const Form = GenericForm<ForensicInput>();
function forensicInputFormWrapper({ classes, forensicInput, submit, ...rest }: Props) {
    return (
        <Form initialValues={forensicInput} onSubmit={submit} {...rest}>
            <InnerForm classes={classes} />
            <FormErrors />
        </Form>
    );
}

const InnerForm: React.FunctionComponent<StyledComponent> = ({ classes }) => {
    return FormSpy<ForensicInput>({
        render: ({ form }) => forensicInputForm({ classes, form }),
    });
};

type InnerProps = StyledComponent & {
    form: FormApi<ForensicInput>;
};

const forensicInputForm: React.FunctionComponent<InnerProps> = ({ form, classes }: InnerProps) => {
    return (
        <Paper className={classes.paper}>
            <FormHeading text="Forensic Input" />
            <Grid container spacing={5} justify="flex-start">
                <Grid item xs={6}>
                    <Grid item xs={12}>
                        <FullWidthDatePicker
                            name="dateReferred"
                            validate={requiredValidator}
                            disableFuture
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <FullWidthDatePicker name="dateFeedbackReceived" disableFuture />
                    </Grid>
                </Grid>
                <Grid item xs={6}>
                    <Grid item xs={12}>
                        <FullWidthSelectField
                            name="reasonForReferral"
                            options={[
                                {
                                    value: 'Astute/VOPD Living Status "alive"',
                                    label: 'Astute/VOPD Living Status "alive"',
                                },
                                {
                                    value:
                                        'Benefit changes or reinstatements within six months of the claim',
                                    label:
                                        'Benefit changes or reinstatements within six months of the claim',
                                },
                                {
                                    value:
                                        'Change in email address from the person who initiated the claim',
                                    label:
                                        'Change in email address from the person who initiated the claim',
                                },
                                {
                                    value: 'Change of Beneficiary/owners/cessionary with 12 months',
                                    label: 'Change of Beneficiary/owners/cessionary with 12 months',
                                },
                                {
                                    value:
                                        'Conflicting information received – (different dates of death, doctors retract statements)',
                                    label:
                                        'Conflicting information received – (different dates of death, doctors retract statements)',
                                },
                                {
                                    value: 'Death occurred outside the borders of RSA',
                                    label: 'Death occurred outside the borders of RSA',
                                },
                                {
                                    value:
                                        'Faulty Notice of Death (serial numbers not corresponding or outstanding information).',
                                    label:
                                        'Faulty Notice of Death (serial numbers not corresponding or outstanding information).',
                                },
                                {
                                    value: 'Flagged Estate Attorney’s as received from GFS',
                                    label: 'Flagged Estate Attorney’s as received from GFS',
                                },
                                {
                                    value: 'Further assessment required',
                                    label: 'Further assessment required',
                                },
                                {
                                    value: 'Large Claim Validation',
                                    label: 'Large Claim Validation',
                                },
                                {
                                    value:
                                        'Misrepresentation or discrepancies of income, occupation, medical history or hazardous activities etc.',
                                    label:
                                        'Misrepresentation or discrepancies of income, occupation, medical history or hazardous activities etc.',
                                },
                                {
                                    value: 'Red flagged Drs and funeral parlours',
                                    label: 'Red flagged Drs and funeral parlours',
                                },
                                {
                                    value: 'Relationship confirmation',
                                    label: 'Relationship confirmation',
                                },
                                {
                                    value: 'Serial Number does not match on the BI',
                                    label: 'Serial Number does not match on the BI',
                                },
                                {
                                    value:
                                        'Surveillance, interviews, financial investigation etc. required.',
                                    label:
                                        'Surveillance, interviews, financial investigation etc. required.',
                                },
                                {
                                    value: 'Suspicion of fraud',
                                    label: 'Suspicion of fraud',
                                },
                                {
                                    value: 'Unnatural deaths',
                                    label: 'Unnatural deaths',
                                },
                                {
                                    value: 'When we are struggling to get confirmations.',
                                    label: 'When we are struggling to get confirmations.',
                                },
                            ]}
                            validate={requiredValidator}
                        />
                        <FullWidthTextField
                            name="forensicDecision"
                            multiline
                            validate={validations.requiredValidator}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Paper>
    );
};

const mapStateToProps: MapStateToProps<StateProps, OwnProps, State> = (state: State) => ({
    forensicInput: getForensicInput(state),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
    dispatch: ThunkDispatch<State, any, AnyAction>
) => ({
    submit: details => dispatch(submitAction(details)),
});

export const ForensicInputForm = connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(forensicInputFormWrapper));
